import { render, staticRenderFns } from "./asset.component.vue?vue&type=template&id=15112210&scoped=true"
import script from "./asset.component.vue?vue&type=script&lang=js"
export * from "./asset.component.vue?vue&type=script&lang=js"
import style0 from "./asset.component.vue?vue&type=style&index=0&id=15112210&prod&lang=scss"
import style1 from "./asset.component.vue?vue&type=style&index=1&id=15112210&prod&lang=scss&scoped=true"
import style2 from "./asset.component.vue?vue&type=style&index=2&id=15112210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15112210",
  null
  
)

export default component.exports